import { Feature } from "geojson";
import { Pharmacy, PharmacyGeoPoint } from "../../@types";

export const normalizeStringCase = (str: string): string =>
  str
    .split(" ")
    .map(s => ucFirst(s))
    .join(" ");

const ucFirst = (str: string): string =>
  str.substring(0, 1).toUpperCase() + str.substring(1).toLowerCase();

export const buildAddress = (address: Feature | undefined): string => {
  if (address) {
    const { properties } = address;
    const { street, city, state, zipcode } = properties as {
      street: string;
      city: string;
      state: string;
      zipcode: string;
    };

    return [street, city, state, zipcode]
      .map(s => s.trim())
      .filter(s => !!s)
      .join(", ");
  } else {
    return "";
  }
};

export const updatePharmacyNetworkStatuses = (
  searchResults: PharmacyGeoPoint[],
  savedPharmacies: Pharmacy[]
): Pharmacy[] => {
  return savedPharmacies.map(pharmacy => {
    const sharedPharmacy = searchResults.find(
      result => result.properties.npi === pharmacy.npi
    );
    return sharedPharmacy
      ? {
          ...pharmacy,
          preferred: sharedPharmacy.properties.preferred,
          in_network: sharedPharmacy.properties.in_network,
        }
      : pharmacy;
  });
};
